import conference from './icons/conference.svg';
import conferenceActive from './icons/conference--active.svg';
import conferenceWhite from './icons/conference--white.svg';
import transcript from './icons/transcript.svg';
import transcriptWhite from './icons/transcript--white.svg';
import transcriptActive from './icons/transcript--active.svg';
import dashboard from './icons/dashboard.svg';
import dashboardActive from './icons/dashboard--active.svg';
import settings from './icons/settings.svg';
import settingsActive from './icons/settings--active.svg';
import superadmin from './icons/superadmin.svg';
import superadminActive from './icons/superadmin--active.svg';
import logout from './icons/logout.svg';
import copyTeal from './icons/copy--teal.svg';
import refreshGrey from './icons/refresh--grey.svg';
import triangleCollapsed from './icons/triangle--collapsed.svg';
import triangleExpanded from './icons/triangle--expanded.svg';
import pencilGrey from './icons/pencil--grey.svg';
import pencilGreyActive from './icons/pencil-edit-button-1_2.svg';
import cross from './icons/cross.svg';
import crossGrey from './icons/cross--grey.svg';
import humanTranscript from './icons/human-transcript.png';
import humanTranscriptActive from './icons/human-transcript--active.png';
import automaticTranscript from './icons/automatic-transcript.png';
import automaticTranscriptActive from './icons/automatic-transcript--active.png';
import plusWhite from './icons/plus--white.svg';
import magnifyingGlass from './icons/magnifying-glass.svg';
import cellPhoneActive from './icons/cell-phone--active.svg';
import cellPhone from './icons/cell-phone.svg';
import phonebook from './icons/phonebook.svg';
import phonebookActive from './icons/phonebook--active.svg';
import canBin from './icons/can-bin--black.png';
import canBinRed from './icons/can-bin--red.png';
import canBinCyan from './icons/can-bin--cyan.png';
import blocked from './icons/blocked.png';
import blockedActive from './icons/blocked--active.png';
import organizations from './icons/organizations.svg';
import organizationsActive from './icons/organizations--active.svg';
import organizationsPrimary from './icons/organizationsPrimary.svg';
import calendar from './icons/calendar.svg';
import calendarActive from './icons/calendar--active.svg';
import edit from './icons/edit.svg';
import editActive from './icons/edit--active.svg';
import phone from './icons/phone.svg';
import phoneActive from './icons/phone--active.svg';
import stop from './icons/stop.svg';
import stopActive from './icons/stop--active.svg';
import phoneBook from './icons/phone-book.svg';
import phoneBookActive from './icons/phone-book--active.svg';
import triangle from './icons/triangle.svg';
import sound from './icons/sound.svg';
import download from './icons/download.svg';
import mail from './icons/mail.svg';

export const sources = {
  conference,
  conferenceActive,
  conferenceWhite,
  transcript,
  transcriptWhite,
  transcriptActive,
  dashboard,
  dashboardActive,
  settings,
  settingsActive,
  superadmin,
  superadminActive,
  logout,
  copyTeal,
  refreshGrey,
  triangleCollapsed,
  triangleExpanded,
  pencilGrey,
  pencilGreyActive,
  cross,
  crossGrey,
  plusWhite,
  humanTranscript,
  humanTranscriptActive,
  automaticTranscript,
  automaticTranscriptActive,
  magnifyingGlass,
  cellPhoneActive,
  cellPhone,
  phonebook,
  phonebookActive,
  canBin,
  canBinRed,
  // FIXME: #703 use proper icon
  blocked,
  blockedActive,
  organizations,
  organizationsActive,
  organizationsPrimary,
  calendar,
  calendarActive,
  edit,
  editActive,
  phone,
  phoneActive,
  stop,
  stopActive,
  phoneBook,
  phoneBookActive,
  canBinCyan,
  triangle,
  sound,
  download,
  mail,
};



// WEBPACK FOOTER //
// ./components/atoms/Icon/sources.js